import React, { FunctionComponent } from 'react';
import { host } from '@Api';
import styles from './right.module.less';

const { imageNew } = host

const tips = ['車室空間', '視野盲區', '底盤舒適', '隔音效果', '迴轉半徑', '操控', '加速', '煞停', '油耗']

const Right: FunctionComponent = () => {

  return (
    <div className={styles["right"]}>
      <div className={styles['supertest-intro']}>
        <img className={styles['supertest-logo']} src={`${imageNew}/article/superTest/logo.png`} alt="" />
        <div className={styles['supertest-context']}>
          “是否覺得如今媒體的話不再那麼可信？想聽到真話？那就讓「汽車自己說話」！車輛究竟好不好，不再憑感覺，一切就讓數據呈現，全臺最詳盡車輛測試報告，盡在8891新車《超級測試》！」
        </div>
      </div>
      <div className={styles['supertest-tips']}>
        <h3>九大測試環節</h3>
        <div className={styles['tips-grid']}>
          {
            tips.map((item, inx) => (
              <div className={styles['supertest-tip']} key={inx}>
                <img src={`${imageNew}/article/superTest/${inx + 1}.svg`} alt="" />
                <p>{item}</p>
              </div>
            ))
          }
        </div>
      </div>
      <div className={styles['supertest-avatar']}>
        <div className={styles['avatar']}>
          <img src="https://photo.8891.com.tw/2021/11/18/1637216122665739.png" alt="" />
          <div className={styles['avatar-tip']}>
            <h3>Jeff</h3>
            <div className={styles['supertest-label']}>
              <p>19年試車經驗</p>
              <p>試駕車數破千</p>
            </div>
          </div>
        </div>
        <div className={styles['avatar-intro']}>
          試車編輯不一定要開得很快，但精準客觀 快速適應車輛，是試車編輯的本職學能！
        </div>
      </div>
    </div>
  )
}

export default Right;
